import { BankAccount } from './BankAccount'
import { TBankAccountProps } from './types'
import BankAccountAbilityProvider from './Providers/BankAccountAbilityProvider'
import BankAccountPopupProvider from './Providers/BankAccountPopupProvider'

export const BankAccountContainer = ({
  businessDetails,
  getBusinessDetails
}: TBankAccountProps) => {
  return (
    <BankAccountAbilityProvider>
      <BankAccountPopupProvider>
        <BankAccount
          businessDetails={businessDetails}
          getBusinessDetails={getBusinessDetails}
        />
      </BankAccountPopupProvider>
    </BankAccountAbilityProvider>
  )
}
